export type DefrostGaugeInput = {
  totalDurationSeconds: unknown;
  stageDurationsSeconds: unknown[];
  elapsedDurationSeconds: unknown;
};

export type DefrostGaugeOutput = {
  defrostPercentage: number;
  defrostTickPercentages: number[];
  totalDurationSeconds: number;
  elapsedDurationSeconds: number;
  stageDurationsSeconds: number[];
};

const coerceSeconds = (value: unknown): number => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  return 0;
};

export const computeDefrostGauge = (input: DefrostGaugeInput): DefrostGaugeOutput => {
  const totalDurationSeconds = coerceSeconds(input.totalDurationSeconds);
  const elapsedDurationSeconds = coerceSeconds(input.elapsedDurationSeconds);
  const stages = Array.isArray(input.stageDurationsSeconds) ? input.stageDurationsSeconds : [];
  const stageDurationsSeconds = stages.map(coerceSeconds);

  if (totalDurationSeconds <= 0) {
    return {
      defrostPercentage: 0,
      defrostTickPercentages: [],
      totalDurationSeconds,
      elapsedDurationSeconds,
      stageDurationsSeconds,
    };
  }

  let cumulative = 0;
  const defrostTickPercentages: number[] = [];
  for (const duration of stageDurationsSeconds) {
    cumulative += duration;
    defrostTickPercentages.push((cumulative / totalDurationSeconds) * 100);
  }

  const defrostPercentage = Math.min((elapsedDurationSeconds / totalDurationSeconds) * 100, 100);

  return {
    defrostPercentage,
    defrostTickPercentages,
    totalDurationSeconds,
    elapsedDurationSeconds,
    stageDurationsSeconds,
  };
};
